import { type usePlanSelectionOptions } from './usePlanSelectionOptions';

export enum PaymentView {
    select_plan = 'select_plan',
    financing_option_selected = 'financing_option_selected',
}

export enum RegisterButtonState {
    processing = 'processing',
    requires_redirect_to_browser = 'requires_redirect_to_browser',
    continue_to_register = 'continue_to_register',
    review_and_register = 'review_and_register',
    register = 'register',
}

export type RegisterButton = {
    registerButtonState: RegisterButtonState;
    text: LocaleString;
};

export type LocaleString = {
    key: string;
};

export type StripeCheckoutSessionParams = {
    admission_offer_id: string;
    product_id: string;
    selected_tuition_plan_id: string;
    // Plan selection sends cohort_id; the re-register screen sends tuition_contract_id instead.
    cohort_id?: string;
    tuition_contract_id?: string;
};

export type SelfRegisterParams = {
    admission_offer_id: string;
    cohort_id: string;
    tuition_plan_id: string;
};

export type CohortDates = {
    beforeRegistrationDeadline: boolean;
    classStartDate: string;
    classStartDateMobile: string;
    inEarlyAdmissionsRegistrationPeriod: boolean;
    registrationDeadline: string;
    registrationDeadlineMobile: string;
    registrationOpenDate: string;
    registerEnabled: boolean;
};

export type CohortRegistrationOption = {
    cohortId: string;
    date: string | null;
};

export type CohortRegistrationOptions = {
    cohortRegistrationOptions: CohortRegistrationOption[];
    showMultipleCohortRegistrationOptions: boolean;
    // Which cohort to register into unless the learner picks another. Null without an offer.
    defaultCohortId: string | null;
};

export type PlanSelectionOptions = ReturnType<typeof usePlanSelectionOptions>;
export type PaymentOption = PlanSelectionOptions['paymentOptions'][number];
export type FinancingOption = PlanSelectionOptions['additionalFinancingOptions'][number];
